import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";

import Create from "./components/create"
import Index from "./components/index"
import Edit from "./components/edit"

function Member(props) {

    return (
        <div>
            <Switch>
                <Route exact path={props.match.path} component={Index}></Route>

                <Route path={`${props.match.path}/create`} component={Create}></Route>

                <Route path={`${props.match.path}/edit/:id`} component={Edit}></Route>

            </Switch>
        </div>
    )
}

export default Member